import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes.ts'

import { RoomEmpty } from 'entities/tour/ui/tour-detail/components/rooms-list/components/room-empty'
import { RoomItem } from 'entities/tour/ui/tour-detail/components/rooms-list/components/room-item'

import { Tour } from 'shared/api/tours/search'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  rooms?: Tour[]
  isSharingMode?: boolean
  isViewMode?: boolean
  onRoomClick?: (room: Tour) => void
}

export const RoomsList = ({
  rooms,
  isSharingMode,
  isViewMode,
  onRoomClick,
}: Props) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const handleClickFilter = () => {
    navigate(RoutingPaths.tours.roomFilter.path())
  }

  const titleText = isViewMode
    ? t('tours_block.your_room')
    : t('tours_block.choose_room')

  return (
    <Paper
      padding={[12, 0, 16, 0]}
      className={s.container}
    >
      <div className={s.header}>
        <p className={clsx('semi-bold-16', s.title)}>{titleText}</p>

        {!isSharingMode && !isViewMode && (
          <div
            className={s.filter}
            onClick={handleClickFilter}
          >
            <AppIcon
              id={AllIcons.FILTERS}
              width={12}
              height={12}
              className={s.swipeIcon}
            />
            <p className={clsx('medium-12', s.filterTitle)}>{t('filter')}</p>
          </div>
        )}
      </div>

      {!!rooms?.length ? (
        <div className={s.list}>
          {rooms?.map((room, index) => (
            <RoomItem
              onRoomClick={() => onRoomClick?.(room)}
              key={room.id || index}
              room={room}
              isViewMode={isViewMode}
            />
          ))}
        </div>
      ) : (
        <RoomEmpty />
      )}
    </Paper>
  )
}
